import { MAIL_SYSTEM_DIRS as MSD } from 'newJs/config';

const { DRAFT, SENT, TRASH, LISTS, SOCIAL, SPAM } = MSD;
const dirEntries = Object.entries(MSD);

export const isExcluded = ((list) => {
    const checkDir = (propName, folderId) => list[propName].some((dir) => folderId.startsWith(dir));
    return {
        recent: (folderId) => checkDir('recent', folderId),
        unread: (folderId) => checkDir('unread', folderId),
    };
})({ // Do not show recent/unread count in the following folders
    recent: [DRAFT, SENT, TRASH],
    unread: [LISTS, SOCIAL, SPAM],
});

export const getFolderIconName = (fullname) => {
    const folderName = dirEntries.find(entry => fullname === entry[1]);

    if (!folderName) return null;

    const shortName = folderName[0].toLowerCase();
    let className = folderName[1] === TRASH
        ? 'ci-icon ci-icon-' + shortName
        : 'ci-icon ci-icon-envelope-' + shortName;

    return className;
};

export const isJunkFolder = (folderId) => [TRASH, SPAM].includes(folderId);

export const addNestingAndSubfolders = (list) => list.map((folder, idx) => {
    let hasSubfolder = false;
    let nesting = 1;

    // Skip 'INBOX' (root) folder
    if (idx > 0) {
        nesting = folder.fullname.split('/').length;
        const nextFolder = list[idx + 1];

        if (nextFolder) {
            const nextNesting = nextFolder.fullname.split('/').length;
            if (nextNesting > nesting) {
                hasSubfolder = true;
            }
        }
    }

    return {
        ...folder,
        hasSubfolder,
        nesting: folder.isSpecial ? 0 : nesting - 1,
    };
});

export const splitFoldersList = (list, countRecent = false) => {
    // console.log('recent', countRecent);
    //if array contains outbox folder move it to 4th position of array
    const outboxIndex = list.findIndex(folder => folder.fullname === 'INBOX/outbox');
    let systemDirCount = 5;
    if (outboxIndex > -1) {
        let outboxFolder = list.splice(outboxIndex, 1)[0];
        outboxFolder.isSpecial = true; //todo remove when mapi is updated- it must return isSpecial: true for outbox
        outboxFolder.nesting = 0; // MAIL-6141 just in same level as all other system folders are
        list.splice(3, 0, outboxFolder);
        systemDirCount = 6;
    }

    const userList = list.slice(systemDirCount);
    return {
        systemFolders: {
            list: list.slice(0, systemDirCount),
        },
        userFolders: {
            list: userList,
            ...(countRecent && {
                recent: userList.reduce((count, item) => {
                    // console.log(item.fullname, item.unread);
                    return isExcluded.recent(item.fullname) ? count : count + item.recent;
                }, 0),
                // unread: otherList.reduce((count, item) => {
                //     return isExcluded.unread(item.id) ? count : count + item.unread;
                // }, 0)
            }),
        },
    };
};
